var map = {
	"./aux-0-white.svg": "./app/assets/status/aux-0-white.svg",
	"./aux-0.svg": "./app/assets/status/aux-0.svg",
	"./aux-1-white.svg": "./app/assets/status/aux-1-white.svg",
	"./aux-1.svg": "./app/assets/status/aux-1.svg",
	"./aux-2-white.svg": "./app/assets/status/aux-2-white.svg",
	"./aux-2.svg": "./app/assets/status/aux-2.svg",
	"./aux-3-white.svg": "./app/assets/status/aux-3-white.svg",
	"./aux-3.svg": "./app/assets/status/aux-3.svg",
	"./aux-4-white.svg": "./app/assets/status/aux-4-white.svg",
	"./aux-4.svg": "./app/assets/status/aux-4.svg",
	"./aux-bottom-0.svg": "./app/assets/status/aux-bottom-0.svg",
	"./aux-bottom-1.svg": "./app/assets/status/aux-bottom-1.svg",
	"./aux-bottom-12.svg": "./app/assets/status/aux-bottom-12.svg",
	"./aux-bottom-123.svg": "./app/assets/status/aux-bottom-123.svg",
	"./aux-bottom-1234.svg": "./app/assets/status/aux-bottom-1234.svg",
	"./aux-bottom-124.svg": "./app/assets/status/aux-bottom-124.svg",
	"./aux-bottom-13.svg": "./app/assets/status/aux-bottom-13.svg",
	"./aux-bottom-134.svg": "./app/assets/status/aux-bottom-134.svg",
	"./aux-bottom-14.svg": "./app/assets/status/aux-bottom-14.svg",
	"./aux-bottom-2.svg": "./app/assets/status/aux-bottom-2.svg",
	"./aux-bottom-23.svg": "./app/assets/status/aux-bottom-23.svg",
	"./aux-bottom-234.svg": "./app/assets/status/aux-bottom-234.svg",
	"./aux-bottom-24.svg": "./app/assets/status/aux-bottom-24.svg",
	"./aux-bottom-3.svg": "./app/assets/status/aux-bottom-3.svg",
	"./aux-bottom-34.svg": "./app/assets/status/aux-bottom-34.svg",
	"./aux-bottom-4.svg": "./app/assets/status/aux-bottom-4.svg",
	"./black-gear.svg": "./app/assets/status/black-gear.svg",
	"./cell-connect-white.svg": "./app/assets/status/cell-connect-white.svg",
	"./cell-connect.svg": "./app/assets/status/cell-connect.svg",
	"./defaultAux.svg": "./app/assets/status/defaultAux.svg",
	"./engine-cut-white.svg": "./app/assets/status/engine-cut-white.svg",
	"./engine-cut.svg": "./app/assets/status/engine-cut.svg",
	"./engine-off.svg": "./app/assets/status/engine-off.svg",
	"./engine-on.svg": "./app/assets/status/engine-on.svg",
	"./fast-acc-white.svg": "./app/assets/status/fast-acc-white.svg",
	"./fast-acc.svg": "./app/assets/status/fast-acc.svg",
	"./fast-dec-white.svg": "./app/assets/status/fast-dec-white.svg",
	"./fast-dec.svg": "./app/assets/status/fast-dec.svg",
	"./forklift.svg": "./app/assets/status/forklift.svg",
	"./green-arrow-up.svg": "./app/assets/status/green-arrow-up.svg",
	"./green-arrow.svg": "./app/assets/status/green-arrow.svg",
	"./green-gear.svg": "./app/assets/status/green-gear.svg",
	"./hand-white.svg": "./app/assets/status/hand-white.svg",
	"./hand.svg": "./app/assets/status/hand.svg",
	"./impact-alert-white.svg": "./app/assets/status/impact-alert-white.svg",
	"./impact-alert.svg": "./app/assets/status/impact-alert.svg",
	"./low-power-white.svg": "./app/assets/status/low-power-white.svg",
	"./low-power.svg": "./app/assets/status/low-power.svg",
	"./max-speed.svg": "./app/assets/status/max-speed.svg",
	"./min-speed.svg": "./app/assets/status/min-speed.svg",
	"./multiple_vehicles.svg": "./app/assets/status/multiple_vehicles.svg",
	"./orange-cloud.svg": "./app/assets/status/orange-cloud.svg",
	"./orange-odometer.svg": "./app/assets/status/orange-odometer.svg",
	"./outside-network-white.svg": "./app/assets/status/outside-network-white.svg",
	"./outside-network.svg": "./app/assets/status/outside-network.svg",
	"./prolonged-idle-white.svg": "./app/assets/status/prolonged-idle-white.svg",
	"./prolonged-idle.svg": "./app/assets/status/prolonged-idle.svg",
	"./red-gear.svg": "./app/assets/status/red-gear.svg",
	"./speed-white.svg": "./app/assets/status/speed-white.svg",
	"./speed.svg": "./app/assets/status/speed.svg",
	"./stopped-white.svg": "./app/assets/status/stopped-white.svg",
	"./stopped.svg": "./app/assets/status/stopped.svg",
	"./temp-alert-white.svg": "./app/assets/status/temp-alert-white.svg",
	"./temp-alert.svg": "./app/assets/status/temp-alert.svg",
	"./theft-alert-end-white.svg": "./app/assets/status/theft-alert-end-white.svg",
	"./theft-alert-end.svg": "./app/assets/status/theft-alert-end.svg",
	"./theft-alert-event.svg": "./app/assets/status/theft-alert-event.svg",
	"./theft-alert-white-new-after.svg": "./app/assets/status/theft-alert-white-new-after.svg",
	"./theft-alert-white.svg": "./app/assets/status/theft-alert-white.svg",
	"./theft-alert.svg": "./app/assets/status/theft-alert.svg",
	"./vehicle-green-test.svg": "./app/assets/status/vehicle-green-test.svg",
	"./vehicle-green.svg": "./app/assets/status/vehicle-green.svg",
	"./vehicle-white.svg": "./app/assets/status/vehicle-white.svg",
	"./weight-white.svg": "./app/assets/status/weight-white.svg",
	"./weight.svg": "./app/assets/status/weight.svg",
	"./white-arrow.svg": "./app/assets/status/white-arrow.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/status sync recursive .svg$";